var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container ai_search_pos chat-container" }, [
    _c(
      "div",
      { staticClass: "card border ai-height" },
      [
        _c(
          "b-row",
          { attrs: { "no-gutters": "" } },
          [
            _c(
              "b-col",
              {
                staticClass: "history-menu sidebar",
                attrs: { cols: "3", id: "sidebar" },
              },
              [
                _c("div", { staticClass: "sidebar-header" }, [
                  _c("span", { staticClass: "sidebar-title" }, [
                    _vm._v("Chats"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "add-chat-btn",
                      attrs: { title: "New chat" },
                      on: { click: _vm.addNewChat },
                    },
                    [_c("fa", { attrs: { icon: ["fas", "plus"] } })],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sidebarbox" },
                  _vm._l(_vm.chats, function (chat, index) {
                    return _c(
                      "b-row",
                      {
                        key: index,
                        class: [
                          "chat mx-auto my-1",
                          _vm.hoveredIndex === index ||
                          _vm.tooltipActiveIndex === index ||
                          _vm.activeChatIndex === index
                            ? "chat-clicked"
                            : "",
                        ],
                        attrs: { "no-gutters": "" },
                        on: {
                          mouseover: function ($event) {
                            _vm.hoveredIndex = index
                          },
                          mouseleave: function ($event) {
                            return _vm.handleMouseLeave(index)
                          },
                          click: function ($event) {
                            return _vm.changeChatLog(chat, index)
                          },
                        },
                      },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "pl-2 chat-title d-flex justify-content-between align-items-center",
                            attrs: { cols: "10" },
                          },
                          [
                            _vm.editIndex !== index
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "chat-title-text text-truncate",
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(chat.title) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newTitle,
                                      expression: "newTitle",
                                    },
                                  ],
                                  ref: "editTitle",
                                  refInFor: true,
                                  staticClass: "form-control form-control-sm",
                                  staticStyle: { "max-width": "70%" },
                                  attrs: { type: "text" },
                                  domProps: { value: _vm.newTitle },
                                  on: {
                                    blur: function ($event) {
                                      return _vm.saveTitle(index)
                                    },
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      return _vm.saveTitle(index)
                                    },
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.newTitle = $event.target.value
                                    },
                                  },
                                }),
                            _vm._v(" "),
                            _c("div", { staticClass: "timestamp" }, [
                              _vm._v(_vm._s(chat.last_updated)),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        (_vm.hoveredIndex === index ||
                          _vm.tooltipActiveIndex === index) &&
                        chat.chatSaved
                          ? _c("b-col", {
                              staticClass: "ml-auto chat-options mr-1",
                              attrs: { cols: "1", id: `chatSettings-${index}` },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-col",
              {
                staticClass: "mainContent",
                attrs: { cols: "9", id: "mainContent" },
              },
              [
                _vm.chats[_vm.activeChatIndex]
                  ? _c(
                      "div",
                      {
                        staticClass: "messages-box",
                        attrs: { id: "messages" },
                      },
                      _vm._l(
                        _vm.chats[_vm.activeChatIndex].messages,
                        function (msg, index) {
                          return _c(
                            "div",
                            { key: index },
                            [
                              _c("div", { staticClass: "chat-messages" }, [
                                msg.requestText && msg.requestTime
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "message user",
                                        staticStyle: { float: "right" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(msg.requestText) +
                                            "\n                "
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "timestamp" },
                                          [_vm._v(_vm._s(msg.requestTime))]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "chat-messages" }, [
                                msg.responseText && msg.responseTime
                                  ? _c("div", { staticClass: "message bot" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(msg.responseText) +
                                          "\n                "
                                      ),
                                      _c("div", { staticClass: "timestamp" }, [
                                        _vm._v(
                                          _vm._s(msg.responseTime) +
                                            "\n                "
                                        ),
                                      ]),
                                    ])
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "message bot no-response",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "typing-indicator",
                                            attrs: {
                                              "data-text": msg.responseText,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(msg.responseText) +
                                                "\n                  "
                                            ),
                                            _c("span", {
                                              staticClass: "dot ml-3",
                                            }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "dot" }),
                                            _vm._v(" "),
                                            _c("span", { staticClass: "dot" }),
                                          ]
                                        ),
                                      ]
                                    ),
                              ]),
                              _vm._v(" "),
                              msg.questionId >= 1 &&
                              msg.responseText &&
                              msg.responseTime
                                ? _c(
                                    "b-row",
                                    { staticClass: "col-md-3 feedbackIcons" },
                                    [
                                      _c(
                                        "b-col",
                                        { staticClass: "col-md-3 center" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(msg.id) +
                                              "\n                "
                                          ),
                                          _c("fa", {
                                            class:
                                              msg.feedback == true
                                                ? "faFeedbackIcon"
                                                : "faIcon",
                                            attrs: {
                                              icon: ["fas", "thumbs-up"],
                                              title: "Like",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.saveFeedback(
                                                  true,
                                                  msg.questionId
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { staticClass: "col-md-3 center" },
                                        [
                                          _c("fa", {
                                            class:
                                              msg.feedback == false
                                                ? "faFeedbackIcon"
                                                : "faIcon",
                                            attrs: {
                                              icon: ["fas", "thumbs-down"],
                                              title: "Dislike",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.saveFeedback(
                                                  false,
                                                  msg.questionId
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        }
                      ),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bottom-container mb-2" },
                  [
                    _c(
                      "b-row",
                      { staticClass: "col-md-5 mt-2" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "col-md-3 center bubble",
                            on: { click: _vm.clearVectorLayers },
                          },
                          [
                            _c("fa", {
                              staticClass: "widgetIcon",
                              attrs: {
                                icon: ["fa", "eraser"],
                                title: "Remove Geometries",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.loading,
                                expression: "loading",
                              },
                            ],
                            staticClass: "col-md-3 center bubble",
                            on: {
                              click: function ($event) {
                                return _vm.getResponse("abort")
                              },
                            },
                          },
                          [
                            _c("fa", {
                              staticClass: "widgetIcon fa-sm",
                              attrs: {
                                icon: ["fa", "stop"],
                                title: "Cancel Query",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "input-group my-2",
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.getResponse("execute")
                          },
                        },
                      },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userInput,
                              expression: "userInput",
                            },
                          ],
                          staticClass:
                            "form-control ai-text p-2 mx-2 border textarea",
                          staticStyle: { "border-radius": "10px" },
                          attrs: {
                            placeholder: "Ask anything...",
                            id: "textarea",
                          },
                          domProps: { value: _vm.userInput },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.getResponse("execute")
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.userInput = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        !_vm.loader
                          ? _c(
                              "button",
                              {
                                staticClass: "btn bot_color mt-2 mr-2 btnstyle",
                                attrs: { type: "submit" },
                                on: {
                                  click: function ($event) {
                                    return _vm.getResponse("execute")
                                  },
                                },
                              },
                              [
                                _c("fa", {
                                  attrs: { icon: ["fas", "arrow-up"] },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.loader
                          ? _c(
                              "button",
                              {
                                staticClass: "btn bot_color mt-2 mr-2 btnstyle",
                                attrs: { disabled: "" },
                              },
                              [_c("fa", { attrs: { icon: ["fas", "sync"] } })],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }